
import { defineComponent, PropType } from 'vue';
import { IBusRoute, IBusStopOfRoute, IStop, IBusN1EstimateTime, IOperator } from '@/types/api/bus';

export default defineComponent({
  name: 'BusRouteInfoDialog',
  props: {
    busOperatorInfo: {
      type: Object as PropType<IOperator>,
      default: () => ({}),
    },
    busRouteInfo: {
      type: Array as PropType<IBusRoute[]>,
      default: () => []
    }
  },
  setup() {
    return {}
  },
})
